<template>
  <div>
    <el-card class="mtf-head">
      <el-row :gutter="20">
        <el-col v-loading="statisticsloading" :span="6">
          <div class="accumulatedL custom-flex-space-between" style="background: rgb(235, 253, 238)">
            <div>
              <!-- <p class="ocean-label">{{ $t('SeaFreight.BLofShipment')+':'+formData.count+' ('+ $t('SeaFreight.Tickets')+')' }}</p> -->
              <p class="ocean-label">{{ $t('SeaFreight.BLofShipment')+':'+formData.count }}</p>
              <!-- <div class="ocean-content">{{ 'FCL'+':'+formData.fclCount+' ('+ $t('SeaFreight.Tickets')+')' }}</div>
              <div class="ocean-content">{{ 'LCL'+':'+formData.lclCount+' ('+ $t('SeaFreight.Tickets')+')' }}</div> -->
              <div class="ocean-content">{{ 'FCL'+':'+formData.fclCount }}</div>
              <div class="ocean-content">{{ 'LCL'+':'+formData.lclCount }}</div>
            </div>
            <img src="@/assets/fms/1.png" style="width: 120px;height: 120px;margin-top: -20px;">
          </div>
        </el-col>
        <el-col v-loading="statisticsloading" :span="6">
          <div class="accumulatedL custom-flex-space-between" style="background: #ffefef">
            <div>
              <div class="ocean-content">{{ $t('SeaFreight.FCL_TEU')+':'+formData.fclteuSum }}</div>
              <div class="ocean-content">{{ $t('SeaFreight.LCL_CBM')+':'+formData.lclcbmSum }}</div>
            </div>
            <img src="@/assets/fms/2.png">
          </div>
        </el-col>
        <el-col v-loading="statisticsloading" :span="4">
          <div class="accumulatedR custom-flex border borderRadius">
            <div>
              <p class="label">{{ $t('SeaFreight.ArrivedatPort') }}</p>
              <div class="custom-flex-space-between svg">
                <img src="@/assets/fms/booking.png" class="svgimg">
                <p class="content">{{ formData.arrivedAtPortTotal }}</p>
              </div>
            </div>
          </div>
        </el-col>
        <el-col v-loading="statisticsloading" :span="4">
          <div class="accumulatedR custom-flex border borderRadius">
            <div>
              <p class="label">{{ $t('SeaFreight.CustomsDeclared') }}</p>
              <div class="custom-flex-space-between svg">
                <img src="@/assets/fms/declared.svg" class="svgimg">
                <p class="content">{{ formData.declaredTotal }}</p>
              </div>
            </div>
          </div>
        </el-col>
        <el-col v-loading="statisticsloading" :span="4">
          <div class="accumulatedR custom-flex border borderRadius">
            <div>
              <p class="label">{{ $t('SeaFreight.Delivered') }}</p>
              <div class="custom-flex-space-between svg">
                <img src="@/assets/fms/sail.svg" class="svgimg">
                <p class="content">{{ formData.deliveredTotal }}</p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-card v-loading="businessloading" class="mt10 minheight350">
          <span class="fw600">{{ $t('SeaFreight.ShipmentStatistics') }}</span>
          <div class="custom-flex-space-between mt16">
            <div class="customblue border borderRadius dian custom-flex-center">{{ $t('SeaFreight.RouteBL') }}</div>
            <!-- <el-date-picker v-model="businessPickerTime" class="custom-input" type="month" format="yyyy-MM" value-format="yyyyMM" :clearable="false" placeholder="月度" size="small" @change="businessChange" /> -->
          </div>
          <BarChart
            id="businessBar"
            ref="businessBar"
            left="2%"
            :yAxisMinInterval="1"
          />
        </el-card>
      </el-col>
      <el-col :span="24">
        <el-card v-loading="cbmloading" class="mt10 minheight350">
          <span class="fw600">{{ $t('SeaFreight.TEUCBMStatistics') }}</span>
          <div class="custom-flex-space-between mt16">
            <div class="customblue border borderRadius dian custom-flex-center">{{ $t('SeaFreight.RouteTEUCBM') }}</div>
            <!-- <el-date-picker v-model="volumePickerTime" class="custom-input" type="month" format="yyyy-MM" value-format="yyyyMM" :clearable="false" placeholder="月度" size="small" @change="volumeChange" /> -->
          </div>
          <BarChart
            id="volumeBar"
            ref="volumeBar"
            left="2%"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getDataStatistics, getBusinessStatisticsTotal, getBusinessStatisticsCBMTotal } from '@/api/ocean/order/oi/index'
import BarChart from '@/components/fms/barChart/index.vue'
import { FormatDate } from '@/utils/isClass'
import i18n from '@/i18n/i18n'
export default {
  components: { BarChart },
  props: {
    timeDimension: {
      type: String,
      default: '1'
    },
    customerCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formData: {},
      businessPickerTime: FormatDate(new Date()),
      volumePickerTime: FormatDate(new Date()),
      statisticsloading: false,
      businessloading: false,
      cbmloading: false
    }
  },
  computed: {},
  watch: {
    timeDimension(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getDataStatistics()
        this.getBusinessTotal()
        this.getCBMTotal()
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
    },
    getList() {
      this.getDataStatistics()
      this.getBusinessTotal()
      this.getCBMTotal()
    },
    /** 查询业务数量 */
    async getDataStatistics() {
      this.statisticsloading = true
      const params = { TimeDimension: this.timeDimension, CustomerCode: this.customerCode }
      var res = await getDataStatistics(params)
      if (res && res.isSuccess) {
        var data = res.data
        this.formData = data
        this.formData.count = data.fclCount + data.lclCount ?? 0
      } else {
        this.messagebox.alert(i18n.t('SeaFreight.QueryFailed'))
      }
      this.statisticsloading = false
    },
    /** 查询业务统计 */
    async getBusinessTotal() {
      this.businessloading = true
      const params = { TimeDimension: this.timeDimension, CustomerCode: this.customerCode }
      var res = await getBusinessStatisticsTotal(params)
      if (res && res.isSuccess) {
        var data = res.data
        data = data.map(item => {
          let name
          if (item.jobType === 'OI') {
            name = (this.$ls.get('lang') === 'zh' ? item.line : item.lineEn) + ' FCL'
          } else if (item.jobType === 'LI') {
            name = (this.$ls.get('lang') === 'zh' ? item.line : item.lineEn) + ' LCL'
          }
          return {
            ...item,
            name
          }
        })
        // 按数量排序
        data = data.sort((a, b) => b.count - a.count)
        // 取前10条数据 10条后的汇总为其他
        const top10Data = data.slice(0, 10)
        const totalCount = data.slice(10).reduce((sum, item) => sum + item.count, 0)
        // OI=FCL LI=LCL
        var dataName = top10Data.map(item => item.name)
        var dataSource = top10Data.map(item => item.count)
        if (totalCount > 0) {
          dataName.push(i18n.t('SeaFreight.Other'))
          dataSource.push(totalCount)
        }
        this.$refs.businessBar.chartInit(dataName, dataSource)
      } else {
        this.messagebox.alert(i18n.t('SeaFreight.QueryFailed'))
      }
      this.businessloading = false
    },
    /** 查询 箱量/体积统计 */
    async getCBMTotal() {
      this.cbmloading = true
      const params = { TimeDimension: this.timeDimension, CustomerCode: this.customerCode }
      var res = await getBusinessStatisticsCBMTotal(params)
      if (res && res.isSuccess) {
        var data = res.data
        data = data.map(item => {
          let count
          let name
          if (item.jobType === 'OI') {
            count = item.tueSum
            name = (this.$ls.get('lang') === 'zh' ? item.line : item.lineEn) + 'FCL'
          } else if (item.jobType === 'LI') {
            count = item.cbmSum
            name = (this.$ls.get('lang') === 'zh' ? item.line : item.lineEn) + 'LCL'
          }
          return {
            ...item,
            count,
            name
          }
        })
        // 按数量排序
        data = data.sort((a, b) => b.count - a.count)
        // 取前10条数据 10条后的汇总为其他
        const top10Data = data.slice(0, 10)
        const teutotal = data.slice(10).reduce((sum, item) => { if (item.jobType === 'OI') { return sum + item.count } return sum }, 0)
        const cbmtotal = data.slice(10).reduce((sum, item) => { if (item.jobType === 'LI') { return sum + item.count } return sum }, 0)
        // OI=FCL LI=LCL
        var dataName = top10Data.map(item => item.name)
        var dataSource = top10Data.map(item => item.count)
        if (teutotal > 0) {
          dataName.push(i18n.t('SeaFreight.OtherBoxQuantities'))
          dataSource.push(teutotal)
        }
        if (cbmtotal > 0) {
          dataName.push(i18n.t('SeaFreight.VolumeOther'))
          dataSource.push(cbmtotal)
        }

        this.$refs.volumeBar.chartInit(dataName, dataSource)
      } else {
        this.messagebox.alert(i18n.t('SeaFreight.QueryFailed'))
      }
      this.cbmloading = false
    },
    /** 业务统计时间选择时间 */
    businessChange() {
      this.getBusinessTotal()
    },
    /**  箱量/体积统计选择时间 */
    volumeChange() {
      this.getCBMTotal()
    }
  }
}
</script>
<style scoped>
.mtf1 {
  margin-top: -1px;
  border-top: #fff;
}
.mtf-head {
  margin-top: -1px;
  border-top: #fff;
}
.mtf-head >>> .el-card__body {
  padding: 0px 20px 20px 20px !important;
}

.mt10 {
  margin-top: 10px;
}
.mt16 {
  margin-top: 16px;
}
.fw600 {
  font-weight: 600;
}
.minheight350 {
  min-height: 350px;
}
.border {
  border: 1px solid #e5e7eb;
}
.borderRadius {
  border-radius: 10px;
}
.dian::before {
  content: '';
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #58c6e4;
  border-radius: 50%;
  margin-right: 6px;
  margin-bottom: 2px;
}
.curMonth {
  padding: 10px 4px;
  background: #f6f6f8;
}
.elSelect {
  width: 180px;
  margin-left: 10px;
  border-radius: 8px;
}
.accumulatedL,
.accumulatedR {
  padding: 16px 24px;
  height: 88px;
}
.accumulatedL .label,
.accumulatedR .label {
  font-size: 12px;
  font-weight: 400;
  color: #4b5563;
}
.accumulatedL .content {
  font-size: 26px;
  font-weight: 600;
  color: #111827;
  margin-top: 14px;
}
.accumulatedR .content {
  font-size: 26px;
  font-weight: 600;
  color: #111827;
  margin: 10px 0 0 8px;
}
.accumulatedL img {
  width: 64px;
  height: 64px;
  display: inline-block;
}
.accumulatedR img {
  width: 30px;
  height: 30px;
  display: inline-block;
  margin-top: 14px;
}
.ocean-label{
  font-size: 13px;
  font-weight: 400;
  color: #4b5563;
}
.ocean-content{
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin: 8px 0 0 8px;
}
.svg{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.svgimg{
    position: relative;
    left: -80px;
    filter: drop-shadow(#3809f3 80px 0);
}
</style>
